export enum LaunchType {
  Pascal = 'pascal', // default
  // integrations
  BetConstruct = 'betconstruct',
  Futureplay = 'futureplay',
  Network1x2 = '1x2network',
  Betfair = 'betfair',
  Relax = 'relax',
  // category specific or lobby
  Lobby = 'lobby', // deprecated
  Replay = 'replay',
  Maintenance = 'maintenance',
  Virtual = 'virtual',
  Cashier = 'cashier',
  Gravity = 'gravity', // deprecated
  Monitor = 'monitor'
}
